import axios from "axios";
import get from "lodash/get";
import {
    formSubmitError,
    formSubmitSuccess,
    isSubmittingForm,
    resetFormStatus,
    settingsIsLoading,
    settingsLoadingSuccess,
    settingsLoadingError,
    announcementsIsLoading,
    announcementsLoadingSuccess,
    announcementsLoadingError,
    isUpdatingForm,
    formUpdateSuccess,
    formUpdateError,
    statisticsIsLoading,
    statisticsLoadingSuccess,
    statisticsLoadingError,
    leadershipBoardIsLoading,
    leadershipBoardLoadingSuccess,
    leadershipBoardLoadingError,
    reportsIsLoading,
    reportsLoadingSuccess,
    reportsLoadingError,
    liveCoursesIsLoading,
    liveCourseLoadingSuccess,
    liveCourseLoadingError,
    monthIsLoading,
    monthLoadingSuccess,
    monthLoadingError,
    subjectIsLoading,
    subjectLoadingSuccess,
    subjectLoadingError,
    sessionTimingIsLoading,
    sessionTimingLoadingSuccess,
    sessionTimingLoadingError,
    classesIsLoading,
    classesLoadingSuccess,
    classesLoadingError,
    tutorIsLoading,
    tutorLoadingSuccess,
    tutorLoadingError,
    studentIsLoading,
    studentLoadingSuccess,
    studentLoadingError,
    beginApproval,
    approvalSuccess,
    approvalError,
    approvalReset,
    degreeIsLoading,
    degreeLoadingError,
    degreeLoadingSuccess,
    specificationIsLoading,
    specificationLoadingSuccess,
    specificationLoadingError,
    ExamspecificationIsLoading,
     ExamspecificationLoadingSuccess,
     ExamspecificationLoadingError,
    getExamIsLoading,
    getExamLoadingSuccess,
    getExamLoadingError,
    getAnnouncementData,
    getAnnouncementSuccess,
    getAnnouncementError,
    reportStudentListIsLoading,
    reportStudentListLoadingSuccess,
    reportStudentListLoadingError,
    reportTutorListIsLoading,
    reportTutorListLoadingSuccess,
    reportTutorListLoadingError,
    reportStudentStatisticsIsLoading,
    reportStudentStatisticsLoadingSuccess,
    reportStudentStatisticsLoadingError,
    reportStudentExamScheduleIsLoading,
    reportStudentExamScheduleLoadingSuccess,
    reportStudentExamScheduleLoadingError,

    reportTutorStatisticsLoadingSuccess,
    reportTutorStatisticsLoadingError,
    reportTutorExamScheduleIsLoading,
    reportTutorExamScheduleLoadingSuccess,
    reportTutorExamScheduleLoadingError,

    reportStudentExamScheduleStatIsLoading,
    reportStudentExamScheduleStatLoadingSuccess,
    reportStudentExamScheduleStatLoadingError,

    reportTutorExamScheduleStatIsLoading,
    reportTutorExamScheduleStatLoadingSuccess,
    reportTutorExamScheduleStatLoadingError,

    statisticsParticpantsIsLoading,
    statisticsParticpantsLoadingSuccess,
    statisticsParticpantsLoadingError,

    scheduleIsLoading,
    scheduleLoadingSuccess,
    scheduleLoadingError,

    attendanceIsLoading,
    attendanceLoadingSuccess,
    attendanceLoadingError,

    attendanceAllIsLoading,
    attendanceAllLoadingSuccess,
    attendanceAllLoadingError,

    attendanceReportIsLoading,
    attendanceReportLoadingSuccess,
    attendanceReportLoadingError,

    attendanceDataIsLoading,
    attendanceDataLoadingSuccess,
    attendanceDataLoadingError

} from "../actions/actions";
const url = "https://simplifyed.io/dev-api/class/";

export const loadSettings = (formData) => {
  return async (dispatch) => {
    dispatch(settingsIsLoading());
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    try {
      let response = await axios.get(
        "https://simplifyed.io/dev-api/class/api/admin/settings",
        {
          headers: { Authorization: "Bearer " + token },
          params: {
            email: formData.email,
            token: token,
          },
        }
      );
      let settingsData = { ...response.data.payload };
      dispatch(settingsLoadingSuccess(settingsData));
    } catch (error) {
      dispatch(settingsLoadingError(error.message));
    }
  };
};

export const updateProfile = (formData) => {
  return async (dispatch) => {
    dispatch(isUpdatingForm());
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    try {
      let response = await axios.post(
        url + "api/admin/updateProfile",
        formData,
        { headers: { Authorization: "Bearer " + token } }
      );
      if (!response.status === 200) {
        dispatch(
          formUpdateError(
            "Server Rejected Data! with error code: " + response.status
          )
        );
      }
      dispatch(formUpdateSuccess());
      dispatch(resetFormStatus());
    } catch (error) {
      dispatch(formUpdateError(error.message));
    }
  };
};

export const submitChangePassword = (formData) => {
  return async (dispatch) => {
    dispatch(isSubmittingForm());
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    try {
      let response = await axios.post(
        url + "api/admin/changePassword",
        formData,
        { headers: { Authorization: "Bearer " + token } }
      );
      if (!response.status === 200) {
        dispatch(
          formSubmitError(
            "Server Rejected Data! with error code: " + response.status
          )
        );
      }
      dispatch(formSubmitSuccess());
      dispatch(resetFormStatus());
    } catch (error) {
      dispatch(formSubmitError(error.message));
    }
  };
};

export const loadAnnouncements = () => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(announcementsIsLoading());
    try {
      let response = await axios.get(url + "api/admin/announcements", {
        headers: { Authorization: "Bearer " + token },
      });
      let announcementsData = [...response.data.payload.data];
      while (response.data.payload.next_page_url) {
        response = await axios.get(response.data.payload.next_page_url, {
          headers: { Authorization: "Bearer " + token },
        });
        announcementsData = announcementsData.concat(
          response.data.payload.data
        );
      }
      announcementsData.sort(
        (a, b) => Date.parse(b.created_at) - Date.parse(a.created_at)
      );
      dispatch(announcementsLoadingSuccess(announcementsData));
    } catch (error) {
      dispatch(announcementsLoadingError(error.message));
    }
  };
};

export const submitAnnouncementForm = (formData) => {
  return async (dispatch) => {
    try {
      const token = JSON.parse(
        window.localStorage.getItem("user")
      ).access_token;
      dispatch(isSubmittingForm());
      let response = await axios.post(
        url + "api/admin/announcements",
        formData,
        { headers: { Authorization: "Bearer " + token } }
      );
      if (!response.status === 200) {
        dispatch(
          formSubmitError(
            "Server Rejected Data with error code: " + response.status
          )
        );
      } else {
        dispatch(formSubmitSuccess());
        dispatch(resetFormStatus());
      }
    } catch (error) {
      dispatch(formSubmitError(error.message));
    }
  };
};

export const handleGetAnnouncementDataForLive = (formData) => {
  return async (dispatch) => {
    try {
      const token = JSON.parse(
        window.localStorage.getItem("user")
      ).access_token;
      dispatch(getAnnouncementData());
      let classResponse = await axios.get(url + "api/admin/getClasses", {
        headers: { Authorization: "Bearer " + token },
      });
      // let subjectResponse = await axios.get(url + "api/admin/manageSubjects", { headers: { 'Authorization': 'Bearer ' + token } });
      let degreeResponse = await axios.get(url + "api/admin/getDegree", {
        headers: { Authorization: "Bearer " + token },
      });

      const payload = {
        classes: get(classResponse, "data.payload.data", []),
        subjects: get(degreeResponse, "data.payload", []),
        degree: get(degreeResponse, "data.payload", []),
        specification: [],
      };
      dispatch(getAnnouncementSuccess(payload));
    } catch (error) {
      dispatch(getAnnouncementError(error.message));
    }
  };
};

export const handleGetAnnouncementDataSpecificationForLive = (id) => {
  return async (dispatch) => {
    try {
      const token = JSON.parse(
        window.localStorage.getItem("user")
      ).access_token;
      dispatch(getAnnouncementData());
      let classResponse = await axios.get(url + "api/admin/getClasses", {
        headers: { Authorization: "Bearer " + token },
      });
      // let subjectResponse = await axios.get(url + "api/admin/manageSubjects", { headers: { 'Authorization': 'Bearer ' + token } });
      let degreeResponse = await axios.get(url + "api/admin/getDegree", {
        headers: { Authorization: "Bearer " + token },
      });
      let specificationResponse = await axios.get(
        url + `api/admin/getSpecifications/${id}`,
        { headers: { Authorization: "Bearer " + token } }
      );

      const payload = {
        classes: get(classResponse, "data.payload.data", []),
        subjects: get(degreeResponse, "data.payload", []),
        degree: get(degreeResponse, "data.payload", []),
        specification: get(specificationResponse, "data.payload", []),
      };
      dispatch(getAnnouncementSuccess(payload));
    } catch (error) {
      dispatch(getAnnouncementError(error.message));
    }
  };
};

export const handleGetAnnouncementData = (formData) => {
  return async (dispatch) => {
    try {
      const token = JSON.parse(
        window.localStorage.getItem("user")
      ).access_token;
      dispatch(getAnnouncementData());
      let degreeResponse = await axios.get(url + "api/admin/getDegree", {
        headers: { Authorization: "Bearer " + token },
      });
      let classResponse = await axios.get(url + "api/admin/getClasses", {
        headers: { Authorization: "Bearer " + token },
      });
      const payload = {
        classes: get(classResponse, "data.payload.data", []),
        subjects: get(degreeResponse, "data.payload", []),
        degree: [],
        specification: [],
      };
      dispatch(getAnnouncementSuccess(payload));
    } catch (error) {
      dispatch(getAnnouncementError(error.message));
    }
  };
};

export const getDegree = async () => {
  const token = JSON.parse(window.localStorage.getItem("user")).access_token;

  return axios
    .get(url + "api/admin/getDegree", {
      headers: { Authorization: "Bearer " + token },
    })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      } else {
        console.log("Error", res);
        return [];
      }
    })
    .catch((err) => {
      console.log("Error", err);
    });
};

export const getSpecification = async (id) => {
  const token = JSON.parse(window.localStorage.getItem("user")).access_token;

  return axios
    .get(url + `api/admin/getSpecifications/${id}`, {
      headers: { Authorization: "Bearer " + token },
    })
    .then((res) => {
      if (res.status === 200) {
        console.log(res.data,"res.data");
        return res.data;
      } else {
        console.log("Error", res);
        return [];
      }
    })
    .catch((err) => {
      console.log("Error", err);
    });
};

export const getClasses_ = async () => {
  const token = JSON.parse(window.localStorage.getItem("user")).access_token;

  return axios
    .get(url + "api/admin/getClasses", {
      headers: { Authorization: "Bearer " + token },
    })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      } else {
        console.log("Error", res);
        return [];
      }
    })
    .catch((err) => {
      console.log("Error", err);
    });
};

export const handleGetAnnouncementData1 = (id) => {
  return async (dispatch) => {
    try {
      const token = JSON.parse(
        window.localStorage.getItem("user")
      ).access_token;
      dispatch(getAnnouncementData());
      let degreeResponse = await axios.get(url + "api/admin/getDegree", {
        headers: { Authorization: "Bearer " + token },
      });
      let specificationResponse = await axios.get(
        url + `api/admin/getSpecifications/${id}`,
        { headers: { Authorization: "Bearer " + token } }
      );
      let classResponse = await axios.get(url + "api/admin/getClasses", {
        headers: { Authorization: "Bearer " + token },
      });
      const payload = {
        classes: get(classResponse, "data.payload.data", []),
        subjects: get(degreeResponse, "data.payload", []),
        degree: [],
        specification: get(specificationResponse, "data.payload", []),
      };
      dispatch(getAnnouncementSuccess(payload));
    } catch (error) {
      dispatch(getAnnouncementError(error.message));
    }
  };
};

export const updateAnnouncementForm = (formData, id) => {
  return async (dispatch) => {
    try {
      const token = JSON.parse(
        window.localStorage.getItem("user")
      ).access_token;
      dispatch(isSubmittingForm());
      let response = await axios.post(
        url + "api/admin/announcements/" + id,
        formData,
        { headers: { Authorization: "Bearer " + token } }
      );
      if (!response.status === 200) {
        dispatch(
          formSubmitError(
            "Server Rejected Data with error code: " + response.status
          )
        );
      } else {
        dispatch(formSubmitSuccess());
        dispatch(resetFormStatus());
      }
    } catch (error) {
      dispatch(formSubmitError(error.message));
    }
  };
};

export const deleteAnnouncement = (announcements, id, announcementToRemove) => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(announcementsIsLoading());
    try {
      let response = await axios.delete(url + "api/admin/announcements/" + id, {
        headers: { Authorization: "Bearer " + token },
      });
      if (response.status !== 200) {
        // dispatch(
        //     courseLoadingError(
        //         "Server threw an error with status: " + response.status
        //     )
        // );
      } else {
        dispatch(announcementsLoadingSuccess(announcements));
      }
    } catch (error) {
      dispatch(announcementsLoadingError(error.message));
    }
  };
};

export const getAnnouncement = async (announcementId) => {
  const token = JSON.parse(window.localStorage.getItem("user")).access_token;

  return await axios
    .get(url + "api/admin/announcement/" + announcementId, {
      headers: { Authorization: "Bearer " + token },
    })
    .then((res) => {
      if (res.status === 200) {
        return res.data.payload;
      } else {
        console.log("Error", res);
        return {};
      }
    })
    .catch((err) => {
      console.log("Error", err);
    });
};

export const createAnnouncement = async (data) => {
  const token = JSON.parse(window.localStorage.getItem("user")).access_token;

  return await axios
    .post(url + "api/admin/announcements", data, {
      headers: { Authorization: "Bearer " + token },
    })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      } else {
        console.log("Error", res);
        return {};
      }
    })
    .catch((err) => {
      console.log("Error", err);
    });
};

export const updateAnnouncement = async (announcementId, data = {}) => {
  const token = JSON.parse(window.localStorage.getItem("user")).access_token;

  return await axios
    .post(url + "api/admin/announcements/update/" + announcementId, data, {
      headers: { Authorization: "Bearer " + token },
    })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      } else {
        console.log("Error", res);
        return {};
      }
    })
    .catch((err) => {
      console.log("Error", err);
    });
};

export const loadStatistics = (type, id) => {
  return async (dispatch) => {
    dispatch(statisticsIsLoading());
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    let route =
      type === "main"
        ? "api/admin/dashboard"
        : "api/admin/course_dashboard/" + id;
    try {
      let response = await axios.get(url + route, {
        headers: { Authorization: "Bearer " + token },
      });
      let statisticsData =
        "end_term_quizz" in response.data.payload
          ? [response.data.payload]
          : [...response.data.payload];
      dispatch(statisticsLoadingSuccess(statisticsData));
    } catch (error) {
      dispatch(statisticsLoadingError(error));
    }
  };
};

// Dashboard Apis

export const handleGetDashboardData = () => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(statisticsParticpantsIsLoading());
    try {
      const res = await axios.get(
        "https://simplifyed.io/dev-api/class/api/admin/dashboard",
        { headers: { Authorization: "Bearer " + token } }
      );
      let statisticParticipantsData = {...res.data.payload[0]}
      dispatch(statisticsParticpantsLoadingSuccess(statisticParticipantsData));
    } catch (error) {
      console.log(error.res.data.message);
      dispatch(statisticsParticpantsLoadingError("Smothing went wrong!"));
    }
  };
};


export const loadLeadershipBoard = () => {
  const token = JSON.parse(window.localStorage.getItem("user")).access_token;
  return async (dispatch) => {
    dispatch(leadershipBoardIsLoading());
    try {
      let response = await axios.get(url + "api/admin/leadership_dashboard", {
        headers: { Authorization: "Bearer " + token },
      });
      let leadershipBoardData = [...response.data.payload];
      leadershipBoardData.sort((a, b) => b.scores_count - a.scores_count);
      dispatch(leadershipBoardLoadingSuccess(leadershipBoardData));
    } catch (error) {
      dispatch(leadershipBoardLoadingError(error.message));
    }
  };
};

export const loadReports = () => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(reportsIsLoading());
    try {
      let response = await axios.get(url + "api/admin/analytics/statistics", {
        headers: { Authorization: "Bearer " + token },
      });
      let reportsData = { ...response.data.payload };
      console.log(reportsData);
      dispatch(reportsLoadingSuccess(reportsData));
    } catch (error) {
      dispatch(reportsLoadingError(error.message));
    }
  };
};

export const loadStudentReports = () => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(reportStudentListIsLoading());
    try {
      let response = await axios.get(url + "api/admin/analytics/students", {
        headers: { Authorization: "Bearer " + token },
      });
      let studentsData = { ...response.data.payload };
      console.log(studentsData);
      dispatch(reportStudentListLoadingSuccess(studentsData));
    } catch (error) {
      dispatch(reportStudentListLoadingError(error.message));
    }
  };
};

export const loadTutorsReports = () => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(reportTutorListIsLoading());
    try {
      let response = await axios.get(url + "api/admin/analytics/tutors", {
        headers: { Authorization: "Bearer " + token },
      });
      let TutorsData = { ...response.data.payload };
      console.log(TutorsData);
      dispatch(reportTutorListLoadingSuccess(TutorsData));
    } catch (error) {
      dispatch(reportTutorListLoadingError(error.message));
    }
  };
};


export const loadStudentStatisticReports = (id) => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(reportStudentStatisticsIsLoading());
    try {
      let response = await axios.get(url + "api/admin/analytics/student/"+id, {
        headers: { Authorization: "Bearer " + token },
      });
      let studentStatisticsData = { ...response.data.payload };
      dispatch(reportStudentStatisticsLoadingSuccess(studentStatisticsData));
    } catch (error) {
      console.log(error);
      dispatch(reportStudentStatisticsLoadingError(error.message));
    }
  };
};

export const loadStudentExamScheduleReports = (id) => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(reportStudentExamScheduleIsLoading());
    try {
      let response = await axios.get(url + "api/admin/analytics/getstudentExams/"+id, {
        headers: { Authorization: "Bearer " + token },
      });
      let studentExamScheduleData = { ...response.data.payload };
      console.log(studentExamScheduleData);
      dispatch(reportStudentExamScheduleLoadingSuccess(studentExamScheduleData));
    } catch (error) {
      console.log(error);
      dispatch(reportStudentExamScheduleLoadingError(error.message));
    }
  };
};

export const loadStudentExamScheduleStatisticsReports = (id,scheduleId) => {
  console.log(id,scheduleId);
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(reportStudentExamScheduleStatIsLoading());
    try {
      let response = await axios.get(url + "api/admin/analytics/getstudentExamAnswers/"+id +"/" +scheduleId, {
        headers: { Authorization: "Bearer " + token },
      });
      let studentExamScheduleStatsData = { ...response.data.payload };
      console.log(studentExamScheduleStatsData);
      dispatch(reportStudentExamScheduleStatLoadingSuccess(studentExamScheduleStatsData));
    } catch (error) {
      console.log(error);
      dispatch(reportStudentExamScheduleStatLoadingError(error.message));
    }
  };
};


export const loadTutorStatisticReports = (id) => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(reportStudentStatisticsIsLoading());
    try {
      let response = await axios.get(url + "api/admin/analytics/tutorStatistics/"+id, {
        headers: { Authorization: "Bearer " + token },
      });
      let tutorStatisticsData = { ...response.data.payload };
      dispatch(reportTutorStatisticsLoadingSuccess(tutorStatisticsData));
    } catch (error) {
      console.log(error);
      dispatch(reportTutorStatisticsLoadingError(error.message));
    }
  };
};

export const loadTutorExamScheduleReports = (id) => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(reportTutorExamScheduleIsLoading());
    try {
      let response = await axios.get(url + "api/admin/analytics/tutorExamSchedules/"+id, {
        headers: { Authorization: "Bearer " + token },
      });
      let tutorExamScheduleData = { ...response.data.payload };
      console.log(tutorExamScheduleData);
      dispatch(reportTutorExamScheduleLoadingSuccess(tutorExamScheduleData));
    } catch (error) {
      console.log(error);
      dispatch(reportTutorExamScheduleLoadingError(error.message));
    }
  };
};

export const loadTutorExamScheduleStatisticsReports = (id,scheduleId) => {
  console.log(id,scheduleId);
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(reportTutorExamScheduleStatIsLoading());
    try {
      let response = await axios.get(url + "api/admin/analytics/getTutorExamAnswers/"+id +"/" +scheduleId, {
        headers: { Authorization: "Bearer " + token },
      });
      let TutorExamScheduleStatsData = { ...response.data.payload };
      console.log(TutorExamScheduleStatsData);
      dispatch(reportTutorExamScheduleStatLoadingSuccess(TutorExamScheduleStatsData));
    } catch (error) {
      console.log(error);
      dispatch(reportTutorExamScheduleStatLoadingError(error.message));
    }
  };
};


export const submitLiveCourseForm = (meetingData, accessToken) => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    try {
      dispatch(isSubmittingForm());
      console.log(accessToken);
      let response = await axios.post(
        "https://webexapis.com/v1/meetings",
        meetingData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      console.log(response.data);
      let createdMeeting = response.data;
      let formData = {
        meeting_id: createdMeeting.id,
        meeting_number: createdMeeting.meetingNumber,
        title: createdMeeting.title,
        agenda: createdMeeting.agenda,
        start: createdMeeting.start,
        end: createdMeeting.end,
        host_user_id: createdMeeting.hostUserId,
        host_email: createdMeeting.hostEmail,
        host_name: createdMeeting.hostDisplayName,
        host_key: createdMeeting.hostKey,
        web_link: createdMeeting.webLink,
        class_id: meetingData.class_id,
      degree_id: meetingData.degree_id,
      specification_id: meetingData.specification_id,
      session_for: meetingData.session_for,
      };
      response = await axios.post(url + "api/admin/meetings", formData, {
        headers: { Authorization: "Bearer " + token },
      });
      if (!response.status === 200) {
        dispatch(
          formSubmitError(
            "Server Rejected Data with error code: " + response.status
          )
        );
      } else {
        dispatch(formSubmitSuccess());
        dispatch(resetFormStatus());
      }
    } catch (error) {
      console.log(error.response.data.message);
      dispatch(formSubmitError(error.response.data.message));
    }
  };
};

export const loadLiveCourses = () => {
  return async (dispatch) => {
    dispatch(liveCoursesIsLoading());
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    try {
      let response = await axios.get(url + "api/admin/meetings", {
        headers: { Authorization: "Bearer " + token },
      });
      console.log(response,"response");
      let liveCourseData = [...response.data.payload.data];
      while (response.data.payload.next_page_url) {
        response = await axios.get(response.data.payload.next_page_url, {
          headers: { Authorization: "Bearer " + token },
        });
        liveCourseData = liveCourseData.concat(response.data.payload.data);
      }
      liveCourseData.sort(
        (a, b) => Date.parse(b.created_at) - Date.parse(a.created_at)
      );
      dispatch(liveCourseLoadingSuccess(liveCourseData));
    } catch (error) {
      console.log(error,"error");
      dispatch(liveCourseLoadingError(error.message));
    }
  };
};

export const deleteCourse = (courses, id, coursesToRemove) => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(liveCoursesIsLoading());
    try {
      let response = await axios.delete(url + "api/admin/meetings/" + id, {
        headers: { Authorization: "Bearer " + token },
      });
      if (response.status !== 200) {
        // dispatch(
        //     courseLoadingError(
        //         "Server threw an error with status: " + response.status
        //     )
        // );
      } else {
        dispatch(liveCourseLoadingSuccess(courses));
      }
    } catch (error) {
      dispatch(liveCourseLoadingError(error.message));
    }
  };
};

export const loginUser = async (loginDetails) => {
  try {
    let response = await axios.post(
      "https://simplifyed.io/dev-api/class/api/admin/login",
      loginDetails
    );
    console.log(response.data.payload);
    return response.data.payload;
  } catch (error) {
    throw error;
  }
};

export const changeCalendarSlotType = async (id, date, status) => {
  const token = JSON.parse(window.localStorage.getItem("user")).access_token;
  try {
    let body = {
      calendar_id: Number(id),
      date: date,
      status: Number(status),
    };
    let response = await axios.post(
      "https://simplifyed.io/dev-api/class/api/admin/add/leave",
      body,
      { headers: { Authorization: "Bearer " + token } }
    );
    console.log(response);
    return true;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const logout = async () => {
  const token = JSON.parse(window.localStorage.getItem("user")).access_token;
  try {
    await axios.post("https://simplifyed.io/dev-api/class/api/admin/logout", {
      headers: { Authorization: "Bearer " + token },
    });
    return true;
  } catch (error) {
    throw error;
  }
};

export const loadMonth = (year, month) => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    console.log(token, "token");
    dispatch(monthIsLoading());
    try {
      let response = await axios.get(
        `https://simplifyed.io/dev-api/class/api/admin/calendar/${year}/${month}`,
        { headers: { Authorization: "Bearer " + token } }
      );
      let calendarData = [...response.data.payload];
     
      dispatch(monthLoadingSuccess(calendarData));
    } catch (error) {
      console.log(error.response);
      dispatch(monthLoadingError(error.response));
    }
  };
};

export const loadSubjects = () => {
  return async (dispatch) => {
    dispatch(subjectIsLoading());
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    try {
      let response = await axios.get(
        "https://simplifyed.io/dev-api/class/api/admin/manageSubjects",
        { headers: { Authorization: "Bearer " + token } }
      );
      let subjectData = [...response.data.payload.data];
      while (response.data.payload.next_page_url) {
        response = await axios.get(response.data.payload.next_page_url, {
          headers: { Authorization: "Bearer " + token },
        });
        subjectData = subjectData.concat(response.data.payload.data);
      }
      dispatch(subjectLoadingSuccess(subjectData));
    } catch (error) {
      dispatch(subjectLoadingError(error.message));
    }
  };
};

export const loadSessionTimings = () => {
  return async (dispatch) => {
    dispatch(sessionTimingIsLoading());
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    try {
      let response = await axios.get(
        "https://simplifyed.io/dev-api/class/api/admin/manageSessions",
        { headers: { Authorization: "Bearer " + token } }
      );
      let sessionTimingData = [...response.data.payload.data];
      while (response.data.payload.next_page_url) {
        response = await axios.get(response.data.payload.next_page_url, {
          headers: { Authorization: "Bearer " + token },
        });
        sessionTimingData = sessionTimingData.concat(
          response.data.payload.data
        );
      }
      dispatch(sessionTimingLoadingSuccess(sessionTimingData));
    } catch (error) {
      dispatch(sessionTimingLoadingError(error.message));
    }
  };
};

export const loadTeachers = async (subjectId) => {
  const token = JSON.parse(window.localStorage.getItem("user")).access_token;
  try {
    console.log(subjectId);
    let response = await axios.get(
      "https://simplifyed.io/dev-api/class/api/admin/tutorSubjects/" + subjectId,
      { headers: { Authorization: "Bearer " + token } }
    );
    let teachersData = [...response.data.payload];
    while (response.data.payload.next_page_url) {
      response = await axios.get(response.data.payload.next_page_url, {
        headers: { Authorization: "Bearer " + token },
      });
      teachersData = teachersData.concat(response.data.payload);
    }
    console.log(teachersData);
    return teachersData;
  } catch (error) {
    console.log(error.response.data);
    throw error;
  }
};

export const setTeacher = async (
  classId,
  selectedTeacher,
  sessionId,
  selectedValue,
  slot,
  degree,
  specification
) => {
  const token = JSON.parse(window.localStorage.getItem("user")).access_token;
  console.log(slot);
  try {
    let body = {
      class_id: Number(classId),
      tutor_id: Number(selectedTeacher),
      session_id: Number(sessionId) + 1,
      subject_id: Number(selectedValue),
      degree_id: Number(degree),
      specification_id: Number(specification),
      date: slot,
    };
    console.log(body);
    let response = await axios.post(
      "https://simplifyed.io/dev-api/class/api/admin/schedule",
      body,
      { headers: { Authorization: "Bearer " + token } }
    );
    console.log(response);
    return response.status === 200;
  } catch (error) {
    console.log(error.response.data);
    throw error.response.data;
  }
};

export const getClasses = () => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(classesIsLoading());
    try {
      let response = await axios.get(
        "https://simplifyed.io/dev-api/class/api/admin/getClasses",
        { headers: { Authorization: "Bearer " + token } }
      );
      console.log(response, "classes");
      let classData = [...response.data.payload.data];
      while (response.data.payload.next_page_url) {
        response = await axios.get(response.data.payload.next_page_url, {
          headers: { Authorization: "Bearer " + token },
        });
        classData = classData.concat(response.data.payload.data);
      }
      dispatch(classesLoadingSuccess(classData));
    } catch (error) {
      console.log(error.response);
      dispatch(classesLoadingError(error));
    }
  };
};

export const loadTutors = () => {
  return async (dispatch) => {
    dispatch(tutorIsLoading());
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    try {
      let response = await axios.get(
        "https://simplifyed.io/dev-api/class/api/admin/manageTutors",
        { headers: { Authorization: "Bearer " + token } }
      );
      let tutorsData = [...response.data.payload.data];
      while (response.data.payload.next_page_url) {
        response = await axios.get(response.data.payload.next_page_url, {
          headers: { Authorization: "Bearer " + token },
        });
        tutorsData = tutorsData.concat(response.data.payload.data);
      }
      // topicsData.sort(
      //     (a, b) => Date.parse(a.created_at) - Date.parse(b.created_at)
      // );
      dispatch(tutorLoadingSuccess(tutorsData));
    } catch (error) {
      console.log(error.response);
      dispatch(tutorLoadingError(error.message));
    }
  };
};

export const loadStudents = () => {
  return async (dispatch) => {
    dispatch(studentIsLoading());
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    try {
      let response = await axios.get(
        "https://simplifyed.io/dev-api/class/api/admin/manageStudents",
        { headers: { Authorization: "Bearer " + token } }
      );
      let studentsData = [...response.data.payload.data];
      while (response.data.payload.next_page_url) {
        response = await axios.get(response.data.payload.next_page_url, {
          headers: { Authorization: "Bearer " + token },
        });
        studentsData = studentsData.concat(response.data.payload.data);
      }
      // topicsData.sort(
      //     (a, b) => Date.parse(a.created_at) - Date.parse(b.created_at)
      // );
      console.log(studentsData);
      dispatch(studentLoadingSuccess(studentsData));
    } catch (error) {
      console.log(error.response);
      dispatch(studentLoadingError(error.message));
    }
  };
};

export const updateTutor = (tutorId, status, tutors) => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(approvalReset());
    dispatch(beginApproval());
    let body = {
      tutor_id: tutorId,
      status: status,
    };
    try {
      await axios.put(
        "https://simplifyed.io/dev-api/class/api/admin/updateTutor",
        body,
        { headers: { Authorization: "Bearer " + token } }
      );
      let newTutors = tutors.map((tutor) =>
        tutor.id === tutorId ? { ...tutor, status: status } : tutor
      );
      dispatch(tutorLoadingSuccess(newTutors));
      dispatch(approvalSuccess());
    } catch (error) {
      console.log(error.response);
      dispatch(approvalError("Smothing went wrong!"));
    }
  };
};

export const updateStudents = (studentId, classId, status, students) => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(approvalReset());
    dispatch(beginApproval());
    let body = {
      student_id: studentId,
      class_id: Number(classId),
      status: status,
    };
    try {
      await axios.put(
        "https://simplifyed.io/dev-api/class/api/admin/updateStudent",
        body,
        { headers: { Authorization: "Bearer " + token } }
      );
      let newStudents = students.map((student) =>
        student.id === studentId ? { ...student, status: status } : student
      );
      dispatch(studentLoadingSuccess(newStudents));
      dispatch(approvalSuccess());
    } catch (error) {
      console.log(error.response.data.message);
      dispatch(approvalError("Smothing went wrong!"));
    }
  };
};



export const getDegrees = () => {

    return async (dispatch) => {

        const token = JSON.parse(window.localStorage.getItem("user")).access_token

        dispatch(degreeIsLoading())

        try {

            let response = await axios.get("https://simplifyed.io/dev-api/class/api/admin/getDegree", { headers: { 'Authorization': 'Bearer ' + token } });

            console.log(response, "degree")

            let degreeData = [...response.data.payload];

            while (response.data.payload.next_page_url) {

                response = await axios.get(response.data.payload.next_page_url, { headers: { 'Authorization': 'Bearer ' + token } });

                degreeData = degreeData.concat(response.data.payload.data);

            }

            dispatch(degreeLoadingSuccess(degreeData))

        } catch (error) {

            console.log(error.response)

            dispatch(degreeLoadingError(error))

        }

    }

}


export const getExamSpecifications = (id) => {

    return async (dispatch) => {

        const token = JSON.parse(window.localStorage.getItem("user")).access_token

        dispatch( ExamspecificationIsLoading())

        try {

            let response = await axios.get(`https://simplifyed.io/dev-api/class/api/admin/getSpecifications/${id}`, { headers: { 'Authorization': 'Bearer ' + token } });

            console.log(response, "specification")

            let examSchedulespecificationState = [...response.data.payload];

            while (response.data.payload.next_page_url) {

                response = await axios.get(response.data.payload.next_page_url, { headers: { 'Authorization': 'Bearer ' + token } });

                examSchedulespecificationState = examSchedulespecificationState.concat(response.data.payload.data);

            }

            dispatch( ExamspecificationLoadingSuccess(examSchedulespecificationState))

        } catch (error) {

            console.log(error.response)

            dispatch( ExamspecificationLoadingError(error))

        }

    }

}

export const getSpecifications = (id) => {
   if(id!=0)
  {
      return async (dispatch) => {

          const token = JSON.parse(window.localStorage.getItem("user")).access_token

          dispatch(specificationIsLoading())

          try {

              let response = await axios.get(`https://simplifyed.io/dev-api/class/api/admin/getSpecifications/${id}`, { headers: { 'Authorization': 'Bearer ' + token } });

              console.log(response, "specification")

              let specificationData = [...response.data.payload];

              return response.data.payload;
   
          } catch (error) {

              console.log(error.response)

              dispatch(specificationLoadingError(error))

          }

      }
  }
    

}


export const getExamSchedules = () => {

    return async (dispatch) => {

        const token = JSON.parse(window.localStorage.getItem("user")).access_token

        dispatch(getExamIsLoading())

        try {

            let response = await axios.get(`https://simplifyed.io/dev-api/class/api/admin/getExamSchedules`, { headers: { 'Authorization': 'Bearer ' + token } });

            console.log(response, "specification")

            let getExamSchedules = [...response.data.payload.data];

            while (response.data.payload.next_page_url) {

                response = await axios.get(response.data.payload.next_page_url, { headers: { 'Authorization': 'Bearer ' + token } });

                getExamSchedules = getExamSchedules.concat(response.data.payload.data);

            }

            dispatch(getExamLoadingSuccess(getExamSchedules))

        } catch (error) {

            console.log(error.response)

            dispatch(getExamLoadingError(error))

        }

    }

}


export const updateExamSchedule = (obj) => {

    return async (dispatch) => {

        const token = JSON.parse(window.localStorage.getItem("user")).access_token

        try {

            let response = await axios.put(`https://simplifyed.io/dev-api/class/api/admin/update/schedule`, obj, { headers: { 'Authorization': 'Bearer ' + token } });

            if (response.status !== 200) {

                // dispatch(

                //     courseLoadingError(

                //         "Server threw an error with status: " + response.status

                //     )

                // );

            } else {

                dispatch(getExamSchedules());

            }

        } catch (error) {

            // dispatch(announcementsLoadingError(error.message));

        }

    }

}


export const deleteExamSchedule = (id) => {

    return async (dispatch) => {

        const token = JSON.parse(window.localStorage.getItem("user")).access_token

        try {

            let response = await axios.delete(`https://simplifyed.io/dev-api/class/api/admin/delete/schedule/${id}`, { headers: { 'Authorization': 'Bearer ' + token } });

            if (response.status !== 200) {

                // dispatch(

                //     courseLoadingError(

                //         "Server threw an error with status: " + response.status

                //     )

                // );

            } else {

                dispatch(getExamSchedules())

            }

        } catch (error) {

            // dispatch(announcementsLoadingError(error.message));

        }

    };

};


export const addExamSchedule = (obj) => {

    return async (dispatch) => {

        const token = JSON.parse(window.localStorage.getItem("user")).access_token

        try {

            let response = await axios.post(`https://simplifyed.io/dev-api/class/api/admin/add/schedule`, obj, { headers: { 'Authorization': 'Bearer ' + token } });

            if (response.status !== 200) {

                // dispatch(

                //     courseLoadingError(

                //         "Server threw an error with status: " + response.status

                //     )

                // );

            } else {

                dispatch(getExamSchedules())

            }

        } catch (error) {

            // dispatch(announcementsLoadingError(error.message));

        }

    };

};

export const loadSchedule = (
  startDate,
  endDate,
  classId,
  degreeId,
  specificationId,
  defaultSchedule = false
) => {
  return async (dispatch) => {
    console.log(degreeId,specificationId);
    dispatch(scheduleIsLoading());
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    
    let body = {
      start_date: startDate,
      end_date: endDate,
      class_id: Number(classId),
      degree_id: Number(degreeId),
      specification_id: Number(specificationId)
    };
     
    let expectedDates = [];
    let start = Number(startDate.substring(startDate.length - 2));
    let end = Number(endDate.substring(endDate.length - 2));
    let restOfTheDate = startDate.substring(0, startDate.length - 2);
    for (let i = start; i <= end; i++) {
      expectedDates.push(restOfTheDate + (i < 10 ? "0" + i : i));
    }
     try {
      let response = await axios.post(
        "https://simplifyed.io/dev-api/class/api/admin/viewSchedules",
        body,
        { headers: { Authorization: "Bearer " + token } }
      );
      
      let scheduleData = { ...response.data.payload };
      let incomingDates = Object.keys(scheduleData);
      let emptySessions = {
        Session1: null,
        Session2: null,
        Session3: null,
        Session4: null,
        Session5: null,
      };
       if (defaultSchedule && incomingDates.length < 6) {
      let newScheduleData = {};
        expectedDates.forEach((date) => {
          console.log( date ,"incomingDates.includes(date)");
          if (!incomingDates.includes(date)) {
            newScheduleData[date] = emptySessions;
          } else {
            newScheduleData[date] = scheduleData[date];
          }
        });
        dispatch(scheduleLoadingSuccess(newScheduleData));
      } else {
        
        dispatch(scheduleLoadingSuccess(scheduleData));
      }
    } catch (error) {
      dispatch(scheduleLoadingError(error.message));
    }
  };
};

export const generateAttendance = async (obj) => {
  try {
        const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    let response = await axios.post(url + "api/admin/generate/attendance", obj, { headers: { 'Authorization': 'Bearer ' + token } });
    console.log(response);
    return true;
  } catch (error) {
    throw error;
  }
};


export const loadAttendance = () => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(attendanceIsLoading());
    try {
      let response = await axios.get(
        `https://simplifyed.io/dev-api/class/api/admin/attendance`,
        { headers: { Authorization: "Bearer " + token } }
      );
      dispatch(attendanceLoadingSuccess(response.data.payload));
    } catch (error) {
      dispatch(attendanceLoadingError(error));
    }
  };
};

export const loadAllAttendance = () => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(attendanceAllIsLoading());
    try {
      let response = await axios.get(
        `https://simplifyed.io/dev-api/class/api/admin/all/attendance`,
        { headers: { Authorization: "Bearer " + token } }
      );
      dispatch(attendanceAllLoadingSuccess(response.data.payload));
    } catch (error) {
      dispatch(attendanceAllLoadingError(error));
    }
  };
};

export const loadAttendanceReport = (obj) => {
  return async (dispatch) => {
    const token = JSON.parse(window.localStorage.getItem("user")).access_token;
    dispatch(attendanceReportIsLoading());
    try {
      let response = await axios.post(
        `https://simplifyed.io/dev-api/class/api/admin/attendance/reports`,obj,
        { headers: { Authorization: "Bearer " + token } }
      );
      console.log(response,"response");
      dispatch(attendanceReportLoadingSuccess(response.data.payload));
    } catch (error) {
      dispatch(attendanceReportLoadingError(error));
    }
  };
};

export const loadAllAttendanceData = () => {
  return async (dispatch) => {
    dispatch(attendanceDataIsLoading());
    try {
      let response = await axios.get(
        `https://simplifyed.io/dev-api/class/api/admin/all/attendance`);
      dispatch(attendanceDataLoadingSuccess(response.data.payload));
    } catch (error) {
      dispatch(attendanceDataLoadingError(error));
    }
  };
};

export const addFeedback = async (feedback) => {
  try {
    let response = await axios.post(url + "api/student/add/feedback", feedback);
    console.log(response.data.payload);
    return true;
  } catch (error) {
    throw error;
  }
};